/**
 * El control del filtro por conductor en blacklist (BB-2608): tres posiciones, Todos / Sin blacklist /
 * Solo blacklist. La traducción a `criterios` vive en `../blacklist.ts` y tiene sus tests; aquí solo
 * se pinta y se conecta.
 *
 * Un `SegmentedControl` y no un desplegable: son tres estados exclusivos y los tres caben a la vista,
 * así que se lee de un vistazo cuál está activo — en un desplegable cerrado, "Todos" y "Sin blacklist"
 * ocupan lo mismo. Va dentro de un `Input.Wrapper` para llevar label y la `description` de una línea
 * como los demás filtros, que es lo que los mantiene alineados en la fila.
 */
import { Group, Input, SegmentedControl } from '@mantine/core';

import { ETIQUETA_FILTRO_BLACKLIST, type FiltroBlacklist as Filtro } from '../blacklist';

const ORDEN: readonly Filtro[] = ['todos', 'excluir', 'solo'];

export function FiltroBlacklist({
  filtro,
  onCambiar,
}: {
  filtro: Filtro;
  onCambiar: (filtro: Filtro) => void;
}) {
  return (
    <Input.Wrapper
      label={
        // Misma altura que la etiqueta de certificacion, que lleva dentro el interruptor Periodo |
        // Fichero: sin esto, titulo, descripcion y control quedaban 8 px mas arriba que los de al lado.
        <Group component="span" mih={33} align="center" wrap="nowrap">
          Conductor en blacklist
        </Group>
      }
      description="Todos = sin filtro, como hasta ahora"
    >
      <SegmentedControl
        mt={4}
        fullWidth
        aria-label="Conductor en blacklist"
        value={filtro}
        onChange={(v) => onCambiar(v as Filtro)}
        data={ORDEN.map((value) => ({ value, label: ETIQUETA_FILTRO_BLACKLIST[value] }))}
      />
    </Input.Wrapper>
  );
}
